import { apiSlice } from "@/redux/apiSlice";

export const orderApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        postOrder: build.mutation({
            query: (body) => ({
                url: "/api/user/order/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        putConfirmOrder: build.mutation({
            query: (body) => ({
                url: `/api/user/order/v1/${body.orderId}/confirm`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        putModifyOrder: build.mutation({
            query: (body) => ({
                url: `/api/user/order/v1/${body.orderId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        getOrderDetail: build.mutation({
            query: (orderId) => ({
                url: `/api/user/order/v1/${orderId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        getOrderLiveList: build.mutation({
            query: ({ params }) => ({
                url: "/api/user/order/v1/live",
                method: "get",
                headers: { token: true },
                params: { ...params },
            }),
        }),

        getAssignedOrderList: build.mutation({
            query: ({ params }) => ({
                url: "/api/user/order/v1/me",
                method: "get",
                headers: { token: true },
                params: { ...params },
            }),
        }),

        getRequestedOrderList: build.mutation({
            query: ({ params }) => ({
                url: "/api/user/order/v1/my_request",
                method: "get",
                headers: { token: true },
                params: { ...params },
            }),
        }),

        getOrderChat: build.mutation({
            query: (orderId) => ({
                url: `/api/user/order/v1/${orderId}/order_chat`,
                method: "get",
                headers: { token: true },
            }),
        }),

        postOrderChat: build.mutation({
            query: ({ orderId, content }) => ({
                url: `/api/user/order/v1/${orderId}/order_chat`,
                method: "post",
                headers: { token: true },
                data: { content },
            }),
        }),

        // 요청 취소
        putRequestCancel: build.mutation({
            query: ({ orderId }) => ({
                url: `/api/user/order/v1/${orderId}/request_cancel`,
                method: "put",
                headers: { token: true },
            }),
        }),

        // 배차 취소
        putOrderCancel: build.mutation({
            query: ({ orderId, content }) => ({
                url: `/api/user/order/v1/${orderId}/order_cancel`,
                method: "put",
                headers: { token: true },
                data: content,
            }),
        }),
    }),
});

export const {
    usePostOrderMutation,
    usePutConfirmOrderMutation,
    usePutModifyOrderMutation,
    useGetOrderDetailMutation,
    useGetOrderLiveListMutation,
    useGetAssignedOrderListMutation,
    useGetRequestedOrderListMutation,
    useGetOrderChatMutation,
    usePostOrderChatMutation,
    usePutRequestCancelMutation,
    usePutOrderCancelMutation,
} = orderApi;
